import React, { useState, useEffect } from 'react';
import Tabs from './components/Tabs';
import SkillsExplorerV2 from './SkillsExplorerV2';
import SkillsImporter from './components/SkillsImporter';
import SkillsAnalytics from './components/SkillsAnalytics';
import { NavigationParams } from '../../utils/navigation';

type TabType = 'viewer' | 'import' | 'analytics';

interface SkillsHierarchyManagerV2Props {
  urlParams?: NavigationParams;
}

const SkillsHierarchyManagerV2: React.FC<SkillsHierarchyManagerV2Props> = ({ urlParams }) => {
  const [activeTab, setActiveTab] = useState<TabType>('viewer');
  const [showHeader, setShowHeader] = useState<boolean>(true);
  const [dashboardStage, setDashboardStage] = useState<0 | 1 | 2>(1);
  const [error, setError] = useState<string | null>(null);

  // Handle URL parameters on mount
  useEffect(() => {
    if (urlParams) {
      // If URL params contain category/skill, switch to viewer tab
      if (urlParams.category || urlParams.skill) {
        setActiveTab('viewer');
      }
    }
  }, []);

  const tabs = [
    { id: 'viewer', label: 'Viewer' },
    { id: 'import', label: 'Import' },
    { id: 'analytics', label: 'Analytics' },
  ];

  return (
    <div className="p-4">
      <div className="mb-4">
        <div className="w-full flex flex-col items-center">
          {showHeader && (
            <div className="max-w-screen-lg w-full">
              <img
                src="/new-talaera-header.png"
                alt="Talaera Header"
                className="w-full h-auto cursor-pointer"
                onClick={() => setShowHeader(false)}
              />
            </div>
          )}
          {dashboardStage !== 0 ? (
            <div className="max-w-screen-lg w-full mt-4">
              <img
                src={dashboardStage === 1 ? '/dashboard1.png' : '/dashboard2.png'}
                alt={dashboardStage === 1 ? 'Dashboard 1' : 'Dashboard 2'}
                className="w-full h-auto cursor-pointer"
                onClick={() => {
                  if (dashboardStage === 1) {
                    setDashboardStage(2);
                  } else {
                    setDashboardStage(0);
                    // Keep header visible when entering the Skills UI
                  }
                }}
              />
            </div>
          ) : (
            !showHeader ? (
              <div className="max-w-screen-lg w-full mt-4">
                <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={(t)=> setActiveTab(t as TabType)} />
              </div>
            ) : null
          )}
        </div>
      </div>
      <div className="mt-4">
        {activeTab === 'viewer' && <SkillsExplorerV2 urlParams={urlParams} />}
        {activeTab === 'import' && (
          <div>
            {error && (
              <div className="mb-4 border border-red-300 bg-red-50 text-red-800 p-3 rounded">
                {error}
              </div>
            )}
            <SkillsImporter onError={setError} />
          </div>
        )}
        {activeTab === 'analytics' && <SkillsAnalytics />}
      </div>
    </div>
  );
};

export default SkillsHierarchyManagerV2;


